// @flow
import React from 'react';
import classnames from 'classnames';

import styles from './toggle.scss';

export default class Toggle extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(ev) {
    ev.stopPropagation();

    if (!this.props.disabled) {
      this.props.onChange(!this.props.value);
    }
  }

  render() {
    const classNames = classnames(styles.toggle, {
      [styles.disabled]: this.props.disabled,
      [styles.on]: this.props.value,
    });

    return (
      <button
        className={classNames}
        onClick={this.handleClick}
        type='button'
        aria-pressed={this.props.value}
      >
        <div className={styles.labelOn}>on</div>
        <div className={styles.labelOff}>off</div>
        <div className={styles.switch} />
      </button>
    );
  }
}

Toggle.defaultProps = {disabled: false};

Toggle.propTypes = {
  value: React.PropTypes.bool.isRequired,
  disabled: React.PropTypes.bool,
  onChange: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/components/toggle.jsx